import {MyopWebComponent} from "../components/myopWebcomponent";
import {BaseMyopLoader} from "./IMyopLoader";
import {loaderOptions} from "../hostSDK.ts";
import {uuidv4, wait} from "../../utils/utils.ts";
import {IComponentDefinitionConfig, ISkinConfig, IWebComponentLoaderConfig, SkinLoaders} from "../../common";

const seen: Record<string, Promise<void>> = {};

export class WebcomponentLoader extends BaseMyopLoader {

    type = SkinLoaders.WebComponentLoader

    load = async (componentDefinition: IComponentDefinitionConfig, skin: ISkinConfig, container: HTMLElement, options?: loaderOptions) => {

        const loaderConfig = (skin.loader as IWebComponentLoaderConfig);

        if (!seen[loaderConfig.url]) {
            // await import( /* @vite-ignore */ webComponentLoadUrl);
            // console.log('module loaded');
            seen[loaderConfig.url] = new Promise((resolve, reject) => {
                const webComponentLoadUrl = loaderConfig.url
                const script = document.createElement('script');
                script.type = 'module';
                script.src = webComponentLoadUrl;
                script.onload = () => {
                    resolve();
                }

                script.onerror = () => {
                    reject();
                }
                document.head.appendChild(script);
            })
        } else {
            console.log('Module alreday loaded or in loading process');
        }

        await seen[loaderConfig.url];

        //TODO : add retry mechanism in fail case.

        //TODO : fix that hack, should fix the race condition for loaded modules
        await wait(1);

        let domId = `myop-comp-${uuidv4()}`
        const element = document.createElement(loaderConfig.tag);

        // TODO : do it only with flag ?
        if (!container.querySelector('[id^="myop-comp-"]'))
            container.innerHTML = '';

        //element.style.visibility = 'hidden';
        element.id = domId;

        if (options?.hidden) {
            element.style.opacity = '0';
            element.style.position = 'absolute'
            element.style.height = '0'
            element.style.width = '0'
            element.style.pointerEvents = 'none'
            element.style.visibility = 'hidden';
        }

        // if (container.id.startsWith('myop-comp-')) {
        //     // in place replacement
        //     container.replaceWith(element);
        //     //container = element.parentElement!;
        // } else {
        //     container.appendChild(element);
        // }

        if(options?._environment){
            // @ts-ignore
            element._myopEnvironment = options?._environment;
        }

        this.appendChild(container, element, options);
        //element.innerHTML = `<${loaderConfig.tag} />`;
        return new MyopWebComponent(componentDefinition, skin, container, element, options);
    }

}
